<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
      <tr>
        <th v-for="header in headers" :key="header.COMP_ID">{{ header.COMP_NAME }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="row in rows" :key="row.PROP">
        <td> {{ row.PROP }}</td>
        <td v-for="(cell) in row.VALUES" :key="cell.COMP_ID">
          {{ numLocaleDecorator(cell.PROP_VALUE) }}
        </td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { RCPT_GET_COMP_PROPERTIES } from '@/store/actions/receptures'
import { UI_SNACKBAR } from '@/store/actions/ui'
import { numDecorator } from '@/components/modules/projects/mixins/numDecorator'
export default {
  name: 'tblCalculationLabData',
  components: {},
  mixins: [numDecorator],
  props: {
    components: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      propertiesData: []
    }
  },
  computed: {
    headers: {
      get () {
        const ret = this.components.map(function (itm) { return { COMP_NAME: itm.COMP_NAME, COMP_ID: itm.COMP_ID } })
        return [{ COMP_NAME: 'Свойство', COMP_ID: '-1' }, ...ret]
      }
    },
    rows: {
      get () {
        const resultMap = new Map()
        this.propertiesData.forEach(element => {
          const propName = String(element.PROP_NAME).concat(', ', element.EI_NAME)
          const compId = element.COMP_ID
          const propValue = element.CURR_PROP_VALUE

          if (!resultMap.has(propName)) {
            resultMap.set(propName, {
              PROP: propName,
              VALUES: []
            })
          }
          resultMap.get(propName).VALUES.push({
            COMP_ID: compId,
            PROP_VALUE: propValue
          })
        })
        return Array.from(resultMap.values())
      }
    }
  },
  watch: {},
  methods: {
    async getProperties () {
      try {
        // Для каждого компонента вызываете ваш бэкэнд для получения свойств
        const promises = this.components.map(async (component) => {
          return await this.fetchPropertiesData(component)
        })

        // Ждем завершения всех запросов
        await Promise.all(promises)
      } catch (err) {
        this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка свойств: \n ${err}` })
      }
    },
    fetchPropertiesData (comp) {
      return this.$store.dispatch(RCPT_GET_COMP_PROPERTIES, { COMP_ID: comp.COMP_ID, ULF_UUID: comp.ULF_UUID })
        .then((res) => {
          this.propertiesData.push(...res)
        })
    }
  },
  mounted () {
    Promise.all([this.getProperties()])
      .then(() => {
        this.loading = false // Устанавливаем флаг загрузки в false
      })
      .catch((err) => {
        this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка получения списка свойств: \n ${err}` })
      })
  }
}
</script>

<style scoped>

</style>
